// extracted by mini-css-extract-plugin
module.exports = {"checkboxContainer":"policy_checkbox_checkboxContainer__1nja_","policyText":"policy_checkbox_policyText__1rKWM"};